import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@repo/ui/components/Base/Dialog";
import { useState } from "react";
import { CircleArrowDown } from "lucide-react";
import { useNestedComponent } from "@repo/ui/components/Base/hooks/useNestedComponent";
import { Button } from "@repo/ui/components/Base/Button";

export interface ExportDialogProps {
  title: React.ReactNode;
  ExportForm: React.FC<{ onCancel?: () => void }>;
}

export const ExportDialog = ({ title, ExportForm }: ExportDialogProps) => {
  const [open, setOpen] = useState(false);

  const handleOpenChange = () => {
    setOpen(!open);
  };

  ExportForm = useNestedComponent(ExportForm);

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogTrigger asChild>
        <Button size={"xs"} className="align-middle">
          <p>Export</p>
          <CircleArrowDown className="ml-1 w-4" />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        {open && <ExportForm onCancel={handleOpenChange} />}
      </DialogContent>
    </Dialog>
  );
};
